import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)


const router = [
  {
    path: '*',
    redirect: '/home'
  },

  {
    path: '/home',
    name: 'home',
    component: Layout,
    redirect: '/homePage',
    children: [
      {
        path: '/homePage',
        name: 'homePage',
        component: resolve => require(['@/view/home/index.vue'], resolve),
        meta: {
          title: 'Home'
        }
      },
      {
        path: '/news',
        name: 'news',
        component: resolve => require(['@/view/home/news.vue'], resolve),
        meta: {
          title: '热点新闻'
        }
      },
      {
        path: '/newsDetail',
        name: 'newsDetail',
        component: resolve => require(['@/view/home/newsDetail.vue'], resolve),
        meta: {
          title: '热点新闻详情'
        }
      },
      {
        path: '/bannerDetail',
        name: 'bannerDetail',
        component: resolve => require(['@/view/home/bannerDetail.vue'], resolve),
        meta: {
          title: 'banner详情'
        }
      },
      {
        path: '/qualification',
        name: 'qualification',
        component: resolve => require(['@/view/link/qualification.vue'], resolve),
        meta: {
          title: '资格赛报名链接'
        }
      },
      {
        path: '/qualificationDetail',
        name: 'qualificationDetail',
        component: resolve => require(['@/view/link/qualificationDetail.vue'], resolve),
        meta: {
          title: '资格赛报名详情'
        }
      },
      {
        path: '/openQualification',
        name: 'openQualification',
        component: resolve => require(['@/view/link/openQualification.vue'], resolve),
        meta: {
          title: '公开赛报名链接'
        }
      },
      {
        path: '/openTournament',
        name: 'openTournament',
        component: resolve => require(['@/view/link/openTournament.vue'], resolve),
        meta: {
          title: '公开赛报名链接'
        }
      },
      {
        path: '/memberApplication',
        name: 'memberApplication',
        component: resolve => require(['@/view/link/memberApplication.vue'], resolve),
        meta: {
          title: '会员申请链接'
        }
      },
      {
        path: '/confirmPayment',
        name: 'confirmPayment',
        component: resolve => require(['@/view/link/confirmPayment.vue'], resolve),
        meta: {
          title: '确认支付'
        }
      },
      {
        path: '/openQualificationPayment',
        name: 'openQualificationPayment',
        component: resolve => require(['@/view/link/openQualificationPayment.vue'], resolve),
        meta: {
          title: '确认支付'
        }
      },


      {
        path: '/mailboxVerification',
        name: 'mailboxVerification',
        component: resolve => require(['@/view/link/mailboxVerification.vue'], resolve),
        meta: {
          title: '邮箱验证'
        }
      },
      {
        path: '/qualificationPayment',
        name: 'qualificationPayment',
        component: resolve => require(['@/view/link/qualificationPayment.vue'], resolve),
        meta: {
          title: '确认支付'
        }
      },
 
      {
        path: '/bonusList',
        name: 'bonusList',
        component: resolve => require(['@/view/bonus/index.vue'], resolve),
        meta: {
          title: 'bonusList'
        }
      },
      {
        path: '/points',
        name: 'points',
        component: resolve => require(['@/view/points/index.vue'], resolve),
        meta: {
          title: 'points'
        }
      },
      {
        path: '/player',
        name: 'player',
        component: resolve => require(['@/view/player/index.vue'], resolve),
        meta: {
          title: '球员'
        },
      },
      {
        path: '/person',
        name: 'person',
        redirect: '/personInfo',
        component: resolve => require(['@/view/player/person.vue'], resolve),
        children: [
          {
            path: '/personInfo',
            name: 'personInfo',
            component: resolve => require(['@/view/player/personInfo.vue'], resolve),
            meta: {
              title: '个人信息'
            }
          },
          {
            path: '/contestResults',
            name: 'contestResults',
            component: resolve => require(['@/view/player/contestResults.vue'], resolve),
            meta: {
              title: '参赛成绩'
            }
          },
          {
            path: '/reportCard',
            name: 'reportCard',
            component: resolve => require(['@/view/player/reportCard.vue'], resolve),
            meta: {
              title: '成绩卡'
            }
          },
          {
            path: '/teStatistics',
            name: 'teStatistics',
            component: resolve => require(['@/view/player/teStatistics.vue'], resolve),
            meta: {
              title: '技术统计'
            }
          },
        ]
      },
      {
        path: '/schedule',
        name: 'schedule',
        component: resolve => require(['@/view/schedule/index.vue'], resolve),
        meta: {
          title: '赛事日程'
        },
      },
      {
        path: '/scheduleInfo',
        name: 'scheduleInfo',
        redirect: '/scheduleHome',
        component: resolve => require(['@/view/schedule/header.vue'], resolve),
        children: [
          {
            path: '/scheduleHome',
            name: 'scheduleHome',
            component: resolve => require(['@/view/schedule/components/scheduleHome.vue'], resolve),
            meta: {
              title: '赛站首页'
            }
          },
          {
            path: '/totalScore',
            name: 'totalScore',
            component: resolve => require(['@/view/schedule/components/totalScore.vue'], resolve),
            meta: {
              title: '总成绩'
            }
          },
          {
            path: '/holeResult',
            name: 'holeResult',
            component: resolve => require(['@/view/schedule/components/holeResult.vue'], resolve),
            meta: {
              title: '逐洞成绩'
            }
          },
          {
            path: '/teeTime',
            name: 'teeTime',
            component: resolve => require(['@/view/schedule/components/teeTime.vue'], resolve),
            meta: {
              title: '开球时间'
            }
          },
          {
            path: '/roster',
            name: 'roster',
            component: resolve => require(['@/view/schedule/components/roster.vue'], resolve),
            meta: {
              title: '球员名单'
            }
          },
          {
            path: '/averageData',
            name: 'averageData',
            component: resolve => require(['@/view/schedule/components/averageData.vue'], resolve),
            meta: {
              title: '平均数据统计'
            }
          },
          {
            path: '/courtIntroduce',
            name: 'courtIntroduce',
            component: resolve => require(['@/view/schedule/components/courtIntroduce.vue'], resolve),
            meta: {
              title: '球场介绍'
            }
          },
          {
            path: '/eventServiceInfo',
            name: 'eventServiceInfo',
            component: resolve => require(['@/view/schedule/components/eventServiceInfo.vue'], resolve),
            meta: {
              title: '赛事服务信息'
            }
          },
        ]
      },

      {
        path: '/user',
        name: 'user',
        component: resolve => require(['@/view/user/index.vue'], resolve),
        children: [
          {
            path: '/userInfo',
            name: 'userInfo',
            redirect: '/personInfouser',
            component: resolve => require(['@/view/user/userInfo.vue'], resolve),
            meta: {
              title: '个人中心首页'
            },
            children: [
              {
                path: '/personInfouser',
                name: 'personInfouser',
                component: resolve => require(['@/view/user/personInfouser.vue'], resolve),
                meta: {
                  title: '个人信息'
                }
              },
              {
                path: '/contestResultsuser',
                name: 'contestResultsuser',
                component: resolve => require(['@/view/user/contestResultsuser.vue'], resolve),
                meta: {
                  title: '参赛成绩'
                }
              },
              {
                path: '/reportCarduser',
                name: 'reportCarduser',
                component: resolve => require(['@/view/user/reportCarduser.vue'], resolve),
                meta: {
                  title: '成绩卡'
                }
              },
              {
                path: '/teStatisticsuser',
                name: 'teStatisticsuser',
                component: resolve => require(['@/view/user/teStatisticsuser.vue'], resolve),
                meta: {
                  title: '技术统计'
                }
              },
            ]
          },
          {
            path: '/basicInfo',
            name: 'basicInfo',
            component: resolve => require(['@/view/user/basicInfo.vue'], resolve),
            meta: {
              title: '基本信息'
            }
          },
          {
            path: '/editPassword',
            name: 'editPassword',
            component: resolve => require(['@/view/user/editPassword.vue'], resolve),
            meta: {
              title: '密码修改'
            }
          },
          {
            path: '/openGame',
            name: 'openGame',
            component: resolve => require(['@/view/user/openGame/index.vue'], resolve),
            meta: {
              title: '公开赛报名'
            }
          },
          {
            path: '/openQualificationIndex',
            name: 'openQualificationIndex',
            component: resolve => require(['@/view/user/openQualificationIndex/index.vue'], resolve),
            meta: {
              title: '公开资格赛报名'
            }
          },
          {
            path: '/applicationPlayer',
            name: 'applicationPlayer',
            component: resolve => require(['@/view/user/openGame/applicationPlayer.vue'], resolve),
            meta: {
              title: '已报名球员列表'
            }
          },
          {
            path: '/qualificationPlayer',
            name: 'qualificationPlayer',
            component: resolve => require(['@/view/user/openQualificationIndex/applicationPlayer.vue'], resolve),
            meta: {
              title: '已报名球员列表'
            }
          },
          {
            path: '/applicationDetail',
            name: 'applicationDetail',
            component: resolve => require(['@/view/user/openGame/applicationDetail.vue'], resolve),
            meta: {
              title: '报名详情'
            }
          },
          {
            path: '/qualificationDetail',
            name: 'qualificationDetail',
            component: resolve => require(['@/view/user/openQualificationIndex/applicationDetail.vue'], resolve),
            meta: {
              title: '报名详情'
            }
          },
          {
            path: '/applicationLink',
            name: 'applicationLink',
            component: resolve => require(['@/view/user/openGame/applicationLink.vue'], resolve),
            meta: {
              title: '公开赛报名路径'
            }
          },
          {
            path: '/qualificationLink',
            name: 'qualificationLink',
            component: resolve => require(['@/view/user/openQualificationIndex/applicationLink.vue'], resolve),
            meta: {
              title: '公开赛报名路径'
            }
          },
          {
            path: '/applicationPay',
            name: 'applicationPay',
            component: resolve => require(['@/view/user/openGame/applicationPay.vue'], resolve),
            meta: {
              title: '确认支付'
            }
          },
          {
            path: '/qualificationPay',
            name: 'qualificationPay',
            component: resolve => require(['@/view/user/openQualificationIndex/applicationPay.vue'], resolve),
            meta: {
              title: '确认支付'
            }
          },
          {
            path: '/count',
            name: 'count',
            component: resolve => require(['@/view/user/bankCount.vue'], resolve),
            meta: {
              title: '银行账户'
            }
          },
          {
            path: '/playerBook',
            name: 'playerBook',
            component: resolve => require(['@/view/user/playerBook.vue'], resolve),
            meta: {
              title: '球员手册下载'
            }
          },
          {
            path: '/bonusUpload',
            name: 'bonusUpload',
            component: resolve => require(['@/view/user/bonusUpload.vue'], resolve),
            meta: {
              title: '奖金信息表下载'
            }
          }
        ]
      },
      {
        path: '/picture',
        name: 'picture',
        component: resolve => require(['@/view/picture/index.vue'], resolve),
        meta: {
          title: '图片'
        }
      },
      {
        path: '/login',
        name: 'login',
        component: resolve => require(['@/view/login/index.vue'], resolve),
        meta: {
          title: '登录'
        },
      }
    ],


  },


]


export default new Router({
  routes: router,
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js